import { render, staticRenderFns } from "./Optezbeaute.vue?vue&type=template&id=9762f2e0&scoped=true"
import script from "./Optezbeaute.vue?vue&type=script&lang=js"
export * from "./Optezbeaute.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/portfolio.css?vue&type=style&index=0&id=9762f2e0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9762f2e0",
  null
  
)

export default component.exports